module.exports = __webpack_public_path__ + "img/printer.8df2fd5f.svg";